// routes.js

import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';

// Import the themed components
import ThemedLanding from './pages/landing/Landing';
import ThemedBase from './pages/base/Base';
import ThemedMission from './pages/mission/Mission';
import ThemedBattlemap from './pages/battle/Battlemap';
import ThemedAfterAction from './pages/afteraction/AfterAction';

// Helper component for dynamic theme routing (landing)
const DynamicThemeLanding = () => {
  const { themeName } = useParams();
  return <ThemedLanding theme={themeName} />;
};

// Helper component for dynamic theme routing (base)
const DynamicThemeBase = () => {
  const { themeName } = useParams();
  return <ThemedBase theme={themeName} />;
};

// Helper component for dynamic theme routing (mission)
const DynamicThemeMission = () => {
  const { themeName } = useParams();
  return <ThemedMission theme={themeName} />;
};

// Helper component for dynamic theme routing (battlemap)
const DynamicThemeBattlemap = () => {
  const { themeName } = useParams();
  return <ThemedBattlemap theme={themeName} />;
};

// Helper component for dynamic theme routing (after action)
const DynamicThemeAfterAction = () => {
  const { themeName } = useParams();
  return <ThemedAfterAction theme={themeName} />;
};

const AppRoutes = () => (
  <Routes>
    {/* Landing page - default vanilla theme */}
    <Route path="/" element={<ThemedLanding />} />
    
    {/* Themed landing pages */}
    {/* Usage: /vanilla, /majestic, /devastators */}
    <Route path="/:themeName" element={<DynamicThemeLanding />} />
    
    {/* Base operations within theme */}
    {/* Usage: /vanilla/base, /majestic/base, /devastators/base */}
    <Route path="/:themeName/base" element={<DynamicThemeBase />} />
    
    {/* Mission briefing within theme */}
    {/* Usage: /vanilla/mission, /majestic/mission, /devastators/mission */}
    <Route path="/:themeName/mission" element={<DynamicThemeMission />} />
    
    {/* Battle/Combat within theme */}
    {/* Usage: /vanilla/battle, /majestic/battle, /devastators/battle */}
    <Route path="/:themeName/battle" element={<DynamicThemeBattlemap />} />
    
    {/* After action report within theme */}
    {/* Usage: /vanilla/after-action, /majestic/after-action, /devastators/after-action */}
    <Route path="/:themeName/after-action" element={<DynamicThemeAfterAction />} />
  </Routes>
);

export default AppRoutes;